document.addEventListener('DOMContentLoaded', function() {
  const myButton = document.getElementById('toggleSearchDisplay'); // Target by ID
  const headerSearchForm = document.querySelector('.header__search-form'); // Target by ID

  if (myButton) { // Check if the button exists
    myButton.addEventListener('click', function() {
        headerSearchForm.classList.toggle('d-none');
    });
  }
});